// extracted by mini-css-extract-plugin
export const container = "hero-module--container--4lLSK";
export const box = "hero-module--box--1Hmb5";
export const clouds = "hero-module--clouds--CzD5U";
export const bus = "hero-module--bus--2SECw";
export const city = "hero-module--city--3cHQL";
export const squares = "hero-module--squares--1qh0D";
export const boxColored = "hero-module--boxColored--2eds2";